import React from 'react';
import { List } from 'antd';
import styled from 'styled-components';
import DocumentTypesListItem from './DocumentTypesListItem';

const DocumentTypesList = ({ documentTypes, loading }) => (
  <DocumentTypesListContainer
    dataSource={documentTypes}
    locale={{
      emptyText:
        loading
        ? 'Carregando tipos de documentos para captura...'
        : 'Este processo não possui documentos para captura via Self Collab'
    }}
    renderItem={documentType =>
      <DocumentTypesListItem documentType={documentType} />
    }
    />
)

const DocumentTypesListContainer = styled(List)`
  .ant-spin-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
`

export default DocumentTypesList;



// WEBPACK FOOTER //
// ./src/components/DocumentTypesList/index.js